export default __webpack_public_path__ + "static/media/vonder.f12576da.jpg";